(function() {
  'use strict';

  angular
    .module('comcom', ['ngAnimate',
                      'ngCookies',
                      'ngTouch',
                      'ngSanitize',
                      'ngMessages',
                      'ngAria',
                      'ngResource',
                      'ui.router',
                      'ui.bootstrap',
                      'toastr',
                      'vcRecaptcha',
                      'ngFileUpload']);

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Less',
        'url': 'http://lesscss.org/',
        'description': 'Less extends the CSS language, adding features that allow variables, mixins, functions and many other techniques.',
        'logo': 'less.png'
      },
      {
        'key': 'jade',
        'title': 'Jade',
        'url': 'http://jade-lang.com/',
        'description': 'Jade is a high performance template engine heavily influenced by Haml and implemented with JavaScript for node.',
        'logo': 'jade.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .service('teamContent', teamContent);

      function teamContent($q, $timeout, $http, $log) {
        var service = {
          getTeamItems: getTeamItems
        };

        return service;

        function getTeamItems() {
          return $http.get('./assets/data/team.json')
            .then(getTeamItemsComplete)
            .catch(getTeamItemsFailed);

          function getTeamItemsComplete(response) {
            return response.data;
          }

          function getTeamItemsFailed(error) {
            $log.error('XHR Failed for getTeamItems.\n' + angular.toJson(error.data, true));
          }
        }
      }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccTeam', ccTeam);

  /** @ngInject */
  function ccTeam() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/team/team.html',
      scope: {},
      controller: TeamController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function TeamController($log, teamContent, $scope, $filter, $location, anchorSmoothScroll) {
      var vm = this;
      vm.teamItems = [],

      activate();

      $scope.gotoElement = function (eID){
        // set the location.hash to the id of
        // the element you wish to scroll to.
        $location.hash(eID);
        // call $anchorScroll()
        anchorSmoothScroll.scrollTo(eID);
      };

      function activate() {
        return getTeamItems().then(function() {
          $log.info('Activated Team View');
        });
      }

      function getTeamItems() {
        return teamContent.getTeamItems().then(function(data) {
          vm.teamItems = data;
          return vm.teamItems;
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .service('anchorSmoothScroll', anchorSmoothScroll);

      function anchorSmoothScroll() {
        this.scrollTo = function(eID) {
          var startY = currentYPosition(),
          stopY = elmYPosition(eID),
          distance = stopY > startY ? stopY - startY : startY - stopY;

          if (distance < 100) {
              scrollTo(0, stopY); return;
          }

          var speed = Math.round(distance / 100);
          if (speed >= 20) speed = 20;
          var step = Math.round(distance / 25),
          leapY = stopY > startY ? startY + step : startY - step,
          timer = 0;

          if (stopY > startY) {
            for (var i = startY; i < stopY; i += step) {
              setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
              leapY += step;
              if (leapY > stopY) leapY = stopY; timer++;
            }
            return;
          }
          for (var i = startY; i > stopY; i -= step) {
            setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
            leapY -= step;
            if (leapY < stopY) leapY = stopY; timer++;
          }

          function currentYPosition() {
            // Firefox, Chrome, Opera, Safari
            if (self.pageYOffset) return self.pageYOffset;
            // Internet Explorer 6 - standards mode
            if (document.documentElement && document.documentElement.scrollTop) return document.documentElement.scrollTop;
            // Internet Explorer 6, 7 and 8
            if (document.body.scrollTop) return document.body.scrollTop;
            return 0;
          }
          function elmYPosition(eID) {
            var elm = document.getElementById(eID),
            y = elm.offsetTop,
            node = elm;
            while (node.offsetParent && node.offsetParent != document.body) {
                node = node.offsetParent;
                y += node.offsetTop;
            }
            return y;
          }
        };
      }
})();

(function() {
  'use strict';


  angular
    .module('comcom')
    .filter('randomize');

  function randomize() {
    return function(input, scope) {
      if (input!=null && input!=undefined && input > 1) {
        return Math.floor((Math.random()*input)+1);
      }
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .service('quoteContent', quoteContent);

      function quoteContent($q, $timeout, $http, $log) {
        var service = {
          getQuoteItems: getQuoteItems
        };

        return service;

        function getQuoteItems() {
          return $http.get('./assets/data/quote.json')
            .then(getQuoteItemsComplete)
            .catch(getQuoteItemsFailed);

          function getQuoteItemsComplete(response) {
            return response.data;
          }

          function getQuoteItemsFailed(error) {
            $log.error('XHR Failed for getQuoteItems.\n' + angular.toJson(error.data, true));
          }
        }
      }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccQuote', ccQuote);

  /** @ngInject */
  function ccQuote() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/quote/quote.html',
      scope: {},
      controller: QuoteController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function QuoteController(quoteContent, $scope, $log) {
      var vm = this;

      vm.quoteItems = [];

      activate();

      function activate() {
        return getQuoteItems().then(function() {
          $log.info('Activated Quote View');
        });
      }

      function getQuoteItems() {
        return quoteContent.getQuoteItems().then(function(data) {
          vm.quoteItems = data;
          return vm.quoteItems;
        });
      }

      $scope.getRandomIndex = function(quoteItems) {
        return Math.floor(Math.random() * vm.quoteItems.length);
      }

      //$scope.randomQuote = vm.quoteItems[Math.floor(Math.random() * $scope.quotes.length)];
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .factory('navbarContent', navbarContent);

    function navbarContent($q, $timeout, $http, $log) {
      var service = {
        getNavbarItems: getNavbarItems
      };

      return service;

      function getNavbarItems() {
        return $http.get('./assets/data/navbar.json')
          .then(getNavbarItemsComplete)
          .catch(getNavbarItemsFailed);

        function getNavbarItemsComplete(response) {
          return response.data;
        }

        function getNavbarItemsFailed(error) {
          $log.error('XHR Failed for getNavbarItems.\n' + angular.toJson(error.data, true));
        }
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccNavbar', ccNavbar);

  /** @ngInject */
  function ccNavbar() {
    var directive = {
      restrict: 'AE',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        brand : '=',
        menus : '=',
        affixed : '=',
        search : '=',
        searchfn : '&',
        navfn : '&',
        inverse : '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($log, navbarContent, $scope, $location, anchorSmoothScroll, $element, $attrs) {
      var vm = this;
      vm.navbarItems = [];
      $scope.isCollapsed = true;
      activate();

      $scope.affixed = "none";

      $scope.gotoElement = function (eID){
        // set the location.hash to the id of
        // the element you wish to scroll to.
        $location.hash(eID);
        // call $anchorScroll()
        anchorSmoothScroll.scrollTo(eID);
      };

      function activate() {
        return getNavbarItems().then(function() {
          $log.info('Activated Navbar View');
        });
      }

      function getNavbarItems() {
        return navbarContent.getNavbarItems().then(function(data) {
          vm.navbarItems = data;
          return vm.navbarItems;
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .service('marketingContent', marketingContent);

      function marketingContent($q, $timeout, $http, $log) {
        var service = {
          getMarketingItems: getMarketingItems
        };

        return service;

        function getMarketingItems() {
          return $http.get('./assets/data/marketing.json')
            .then(getMarketingItemsComplete)
            .catch(getMarketingItemsFailed);

          function getMarketingItemsComplete(response) {
            return response.data;
          }

          function getMarketingItemsFailed(error) {
            $log.error('XHR Failed for getMarketing.\n' + angular.toJson(error.data, true));
          }
        }
      }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccMarketing', ccMarketing);

  /** @ngInject */
  function ccMarketing() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/marketing/marketing.html',
      scope: {},
      controller: MarketingController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MarketingController($log, marketingContent, $scope, $filter) {
      var vm = this;
      vm.marketingItems = [],

      activate();

      function activate() {
        return getMarketingItems().then(function() {
          $log.info('Activated About View');
        });
      }

      function getMarketingItems() {
        return marketingContent.getMarketingItems().then(function(data) {
          vm.marketingItems = data;
          return vm.marketingItems;
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .service('industriesContent', industriesContent);

      function industriesContent($q, $timeout, $http, $log) {
        var service = {
          getIndustriesItems: getIndustriesItems
        };

        return service;

        function getIndustriesItems() {
          return $http.get('./assets/data/industries.json')
            .then(getIndustriesItemsComplete)
            .catch(getIndustriesItemsFailed);

          function getIndustriesItemsComplete(response) {
            return response.data;
          }

          function getIndustriesItemsFailed(error) {
            $log.error('XHR Failed for getIndustriesItems.\n' + angular.toJson(error.data, true));
          }
        }
      }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccIndustries', ccIndustries);

  /** @ngInject */
  function ccIndustries() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/industries/industries.html',
      scope: {},
      controller: IndustriesController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function IndustriesController(industriesContent, $log) {
      var vm = this;

      vm.industriesItems = [];

      activate();

      function activate() {
        return getIndustriesItems().then(function() {
          $log.info('Activated Quote View');
        });
      }

      function getIndustriesItems() {
        return industriesContent.getIndustriesItems().then(function(data) {
          vm.industriesItems = data;
          return vm.industriesItems;
        });
      }

      // $scope.getRandomIndex = function(quoteItems) {
      //   return Math.floor(Math.random() * vm.quoteItems.length);
      // }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccHeader', ccHeader);

  /** @ngInject */
  function ccHeader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/header/header.html',
      scope: {},
      controller: HeaderController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function HeaderController() {
      var vm = this;
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .factory('greetingsContent', greetingsContent);

    function greetingsContent($q, $timeout, $http, $log) {
      var service = {
        getGreetingsItems: getGreetingsItems
      };

      return service;

      function getGreetingsItems() {
        return $http.get('./assets/data/greeting.json')
          .then(getGreetingsItemsComplete)
          .catch(getGreetingsItemsFailed);

        function getGreetingsItemsComplete(response) {
          return response.data;
        }

        function getGreetingsItemsFailed(error) {
          $log.error('XHR Failed for getGreetingsItems.\n' + angular.toJson(error.data, true));
        }
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccGreetings', ccGreetings);

  /** @ngInject */
  function ccGreetings(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: GreetingsController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('greeting-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.greetingItems', function() {
        angular.forEach(vm.greetingItems, function(greeting) {
          typist.type(greeting.greeting).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function GreetingsController($log, greetingsContent) {
      var vm = this;

      vm.greetingItems = [];

      activate();

      function activate() {
        return getGreetingsItems().then(function() {
          $log.info('Activated Greetings View');
        });
      }

      function getGreetingsItems() {
        return greetingsContent.getGreetingsItems().then(function(data) {
          vm.greetingItems = data;

          angular.forEach(vm.greetingItems, function(greetingItem) {
            greetingItem.rank = Math.random();
          });
          return vm.greetingItems;
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccFooter', ccFooter);

  /** @ngInject */
  function ccFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      scope: {},
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController($scope, $log) {
      var vm = this;
      vm.footerItems = [];
      $scope.forms = {};
      $scope.date = new Date();
      $scope.currentTab = './app/components/contact/contact.html';
      $scope.elementTab = 'cc-contact';
      vm.footerItems = [{
          title: 'Contact Us:',
          url: './app/components/contact/contact.html',
          element: 'cc-contact'
      }, {
          title: 'Careers:',
          url: './app/components/careers/careers.html',
          element: 'cc-careers'
      }];

      //$scope.currentTab = 'cc-contact';
      $scope.onClickTab = function (tab) {
          $scope.currentTab = tab.url;
          $scope.elementTab = tab.element;
      }

      $scope.isActiveTab = function(tabUrl) {
          return tabUrl == $scope.currentTab;
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .service('fileUpload', fileUpload);
    function fileUpload($http) {
      var vm = this;

      vm.uploadFileToUrl = function(file, uploadUrl){
        var fd = new FormData();
        fd.append('file', file);
        $http.post(uploadUrl, fd, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        })
        .success(function(){
        })
        .error(function(){
        });
      }
    }
  }
)();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccFileModel', ccFileModel);

  function ccFileModel ($parse) {
    var directive = {
      restrict: 'A',
      link: function(scope, element, attrs, $log) {
          var model = $parse(attrs.fileModel);
          var modelSetter = model.assign;
          $log.info(model);
          $log.info(modelSetter);

          element.bind('change', function(){
              scope.$apply(function(){
                  modelSetter(scope, element[0].files[0]);
                  $log.info(modelSetter);
              });
          });
      }
    };
      return directive;
  }
})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .service('contactContent', contactContent);

      function contactContent($q, $timeout, $http, $log) {
        var service = {
          getContactItems: getContactItems
        };

        return service;

        function getContactItems() {
          return $http.get('./assets/data/contact.json')
            .then(getContactItemsComplete)
            .catch(getContactItemsFailed);

          function getContactItemsComplete(response) {
            return response.data;
          }

          function getContactItemsFailed(error) {
            $log.error('XHR Failed for getContactItems.\n' + angular.toJson(error.data, true));
          }
        }
      }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccContact', ccContact);

  /** @ngInject */
  function ccContact() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/contact/contact.html',
      scope: {},
      controller: ContactController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function ContactController(contactContent, $scope, $log, $http, vcRecaptchaService) {
      var vm = this;
      $scope.date = new Date();

      vm.contactForm = {};
      vm.submitted = false;
      vm.error = false;
      vm.errorDesc = '';
      vm.key = '6LfhmBIUAAAAAJcKnOTCaeOWJihe74wFeoTQZMeN';


      $scope.submitData = function (form, resultVarName)
      {
        if(form == undefined)
        {
          vm.error = true;
          vm.errorDesc = 'Please enter all required fields';
          return;
        }
        
        var config = {
          params: form
        };

        $http.post("/contact", null, config)
          .success(function (data, status, headers, config)
          {
            if(data.responseCode == 1) 
            {
              vm.error = true;
              vm.errorDesc = data.responseDesc;
              console.log(data.responseDesc);
              return;
            }

            $scope[resultVarName] = data;
            vm.error = false;
            vm.submitted = true;
          })
          .error(function (data, status, headers, config)
          {
            $scope[resultVarName] = "SUBMIT ERROR";
          });
      };
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccCareers', ccCareers);

  /** @ngInject */
  function ccCareers() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/careers/careers.html',
      scope: {},
      controller: CareersController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CareersController($scope, $http, $log, $timeout, Upload) {
      var vm = this;
      $scope.date = new Date();

      vm.careersForm = {};
      vm.submitted = false;
      vm.key = '6LfhmBIUAAAAAJcKnOTCaeOWJihe74wFeoTQZMeN';
      vm.error = false;
      vm.errorDesc = '';

      $scope.submitData = function (form, resultVarName)
      {
        var config = {
          params: form
        };
        if(form == undefined)
        {
          vm.error = true;
          vm.errorDesc = 'Please enter all required fields';
          return;
        }

        form.upload = Upload.upload({
          url: '/careers',
          data: {
            file: form.file,
            name: form.name,
            email: form.email,
            phone: form.phone,
            message: form.message,
            captchaResponse: form.captchaResponse,
            field: form.field
          },
        });

        form.upload.then(function(response) {
          $timeout(function() {
            form.result = response.data;
            console.log("Response is..");
            console.dir(response);
            vm.submitted = true;
            vm.error = false;
          });
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          form.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      };
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('backImg', backImg);

  function backImg () {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attrs){
      var url = attrs.backImg;
      element.css({
        'background-image': 'url(./../assets/img/industries/' + url +')',
        'background-size' : 'cover'
      });
    };
  };
})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .service('aboutContent', aboutContent);

      function aboutContent($q, $timeout, $http, $log) {
        var service = {
          getAboutItems: getAboutItems
        };

        return service;

        function getAboutItems() {
          return $http.get('./assets/data/about.json')
            .then(getAboutItemsComplete)
            .catch(getAboutItemsFailed);

          function getAboutItemsComplete(response) {
            return response.data;
          }

          function getAboutItemsFailed(error) {
            $log.error('XHR Failed for getAbout.\n' + angular.toJson(error.data, true));
          }
        }
      }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .directive('ccAbout', ccAbout);

  /** @ngInject */
  function ccAbout() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/about/about.html',
      scope: {},
      controller: AboutController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AboutController($log, aboutContent, $scope, $filter, $location, anchorSmoothScroll) {
      var vm = this;
      vm.aboutItems = [],

      activate();

      $scope.gotoElement = function (eID){
        // set the location.hash to the id of
        // the element you wish to scroll to.
        $location.hash(eID);
        // call $anchorScroll()
        anchorSmoothScroll.scrollTo(eID);
      };

      function activate() {
        return getAboutItems().then(function() {
          $log.info('Activated About View');
        });
      }

      function getAboutItems() {
        return aboutContent.getAboutItems().then(function(data) {
          vm.aboutItems = data;
          return vm.aboutItems;
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('comcom')
      .factory('mainContent', mainContent);

    function mainContent($q, $timeout, $http, $log) {
      var service = {
        getMainItems: getMainItems
      };

      return service;

      function getMainItems() {
        return $http.get('./assets/data/main.json')
          .then(getMainItemsComplete)
          .catch(getMainItemsFailed);

        function getMainItemsComplete(response) {
          return response.data;
        }

        function getMainItemsFailed(error) {
          $log.error('XHR Failed for getMainItems.\n' + angular.toJson(error.data, true));
        }
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $log, mainContent) {
    var vm = this;
    vm.mainItems = {};
    activate();

    function activate() {
      return getMainItems().then(function() {
        $log.info('Activated Main View');
        $scope.title = vm.mainItems.title;
        $scope.keywords = vm.mainItems.keywords;
        $scope.description = vm.mainItems.description;

      });
    }

    function getMainItems() {
      return mainContent.getMainItems().then(function(data) {
        vm.mainItems = data;
        return vm.mainItems;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController() {
    var vm = this;
  }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .controller('ChristmasController', ChristmasController);

  /** @ngInject */
  function ChristmasController() {
    var vm = this;
  }
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $location, $anchorScroll) {
    $anchorScroll.yOffset = 75;
    $log.debug('runBlock end');
    //Lets you jump to an id on the homepage
    $rootScope.$on('$routeChangeSuccess', function(newRoute, oldRoute, scope, next, current) {
      if($location.hash()) $anchorScroll();
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/home/home.html',
        controller: 'HomeController',
        controllerAs: 'vm'
      })
      .state('christmas', {
        url: '/christmas',
        templateUrl: 'app/christmas/christmas.html',
        controller: 'ChristmasController',
        controllerAs: 'vm'
      });

    $locationProvider.hashPrefix('!');
    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false, _:false */
(function() {
  'use strict';

  angular
    .module('comcom')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('_', _);
})();

(function() {
  'use strict';

  angular
    .module('comcom')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("comcom").run(["$templateCache", function($templateCache) {$templateCache.put("app/christmas/christmas.html","<style type=\"text/css\">\n  body {\n    background: url(./../assets/img/christmas/background.png);\n    background-size:cover;\n  }\n  \n</style><div ng-controller=\"ChristmasController\" class=\"comcom christmas-page\"><nav class=\"navbar\"><div class=\"container\"><div class=\"navbar-header\"><a href=\"/\" class=\"navbar-brand\"><img src=\"./assets/img/christmas/logo.png\"></a></div></div></nav><section id=\"header\" class=\"header\"><div class=\"first-quote\"><section class=\"quote\"><div class=\"container-fluid center christmas-video\"><div class=\"video-container\"><div class=\"wistia_responsive_padding\"><div class=\"wistia_responsive_wrapper\"><div class=\"wistia_embed wistia_async_ki3wb0kpwm seo\">0</div></div></div></div></div></section></div></section></div><script charset=\"ISO-8859-1\" src=\"//fast.wistia.com/embed/medias/ki3wb0kpwm.jsonp\"></script><script charset=\"ISO-8859-1\" src=\"//fast.wistia.com/assets/external/E-v1.js\"></script>");
$templateCache.put("app/home/home.html","<div ng-controller=\"HomeController\" class=\"comcom\"><cc-navbar></cc-navbar><cc-header></cc-header><cc-about></cc-about><div class=\"first-quote\"><section class=\"quote ss-style-triangles\"><div class=\"container-fluid center\"><div class=\"quote-container\"><div class=\"quote-image\"><img ng-src=\"./assets/img/quote/quotations_green.png\"></div><div class=\"quote-source\"><div class=\"quote-content\"><p class=\"radikal\">From our beginning in 1997, we have successfully grown 2‑COM by hiring the best employees, creating and utilizing proven technology and providing the most responsible solutions.</p></div><div class=\"quote-source\"><p class=\"italic\">— Amos Jones, President</p></div></div></div></div></section></div><cc-industries></cc-industries><div class=\"second-quote\"><section class=\"quote ss-style-triangles\"><div class=\"container-fluid center\"><div class=\"quote-container\"><div class=\"quote-image\"><img ng-src=\"./assets/img/quote/quotations_white.png\"></div><cc-quote></cc-quote></div></div></section></div><cc-marketing></cc-marketing><cc-team></cc-team><cc-footer></cc-footer></div>");
$templateCache.put("app/components/about/about.html","<section id=\"about\" class=\"about ss-style-triangles\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=\"center about-intro\"><h3>Every organization faces the challenge of producing, maintaining, and distributing product communications and marketing assets.</h3></div></div><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=\"center about-bold\"><h2>That\'s where we, Communication Components (2-COM), fit in.</h2></div></div></div><div class=\"container\"><div class=\"row about-locations\"><div ng-repeat=\"aboutItem in vm.aboutItems\" class=\"about-locations-item center col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div ng-style=\"{\'background-image\':\'url(./../assets/img/about/{{aboutItem.image}})\'}\" class=\"about-locations-item-image\"></div><h4>{{ aboutItem.name }}</h4></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-6 col-lg-6\"><p>Our unique mix of capabilities provides increased efficiencies, lower costs, and faster time-to-market throughout the marketing channels. Our unified approach also ensures uniform branding and consistent marketing messages across all custom and stock communications.</p></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><p>Our team of dedicated professionals combines ownership and focus with structure and process to produce high quality results and superior customer service. Above all, we conduct business with integrity, reliability and creativity in everything we do. <a ng-click=\"gotoElement(\'contact\')\" class=\"about-contact\">Looking for a strategic partner? Contact us.</a></p></div></div></div></div></section>");
$templateCache.put("app/components/careers/careers.html","<div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div ng-show=\"vm.error\" class=\"careers-error\"><span>{{vm.errorDesc}}</span></div><form name=\"forms.careersForm\" id=\"careersForm\" ng-show=\"!vm.submitted\" class=\"grid form\"><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"NameCareers\" class=\"form-label required-mark\">Name</label> <input ng-model=\"careers.name\" type=\"text\" id=\"NameCareers\" name=\"NameCareers\" class=\"form-control required\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"EmailCareers\" class=\"form-label required-mark\">Email</label> <input ng-model=\"careers.email\" type=\"email\" id=\"EmailCareers\" name=\"EmailCareers\" class=\"form-control required\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"PhoneCareers\" class=\"form-label\">Phone</label> <input ng-model=\"careers.phone\" type=\"text\" id=\"PhoneCareers\" name=\"PhoneCareers\" class=\"form-control\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"MessageCareers\" class=\"form-label required-mark\">Message</label> <textarea ng-model=\"careers.message\" type=\"text\" id=\"MessageCareers\" name=\"MessageCareers\" class=\"form-control required\"></textarea></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"FieldCareers\" class=\"form-label\">Field of Interest:</label> <input ng-model=\"careers.field\" type=\"text\" id=\"FieldCareers\" name=\"FieldCareers\" class=\"form-control\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><div class=\"col-sm-1-2\"><label for=\"UploadCareers\" class=\"form-label file-upload-label\">Upload Resume:</label></div><div class=\"col-sm-1-2\"><input type=\"file\" ngf-select=\"\" ng-model=\"careers.file\" name=\"file\" accept=\".txt, .doc, .docx, .pdf\" ngf-max-size=\"2MB\" required=\"\" ngf-model-invalid=\"errorFiles\" class=\"form-control file-upload\"><div class=\"form-info\">* PDFs, Docs, and Docx only</div></div></div></div><div class=\"col-sm-1-1\"><div vc-recaptcha=\"\" key=\"vm.key\" ng-model=\"careers.captchaResponse\" class=\"recaptcha\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><btn data-ng-disabled=\"progress.active()\" type=\"submit\" value=\"Submit\" ng-click=\"submitData(careers)\" class=\"btn submit-btn\">Submit</btn></div></div></form><div ng-show=\"vm.submitted\" class=\"careers-submitted\"><h6>Thank you!</h6></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 careers-right-pane\"><div class=\"row\"><div class=\"col-xs-12 no-padding-mobile\"><div class=\"footer-right\"><div class=\"footer-right-header careers-spacing\"><h6>We are always looking for exceptional</h6><h6>people who love what they do.</h6></div><div class=\"footer-right-content-careers careers-spacing\"><h6>Fill out the form to contact our HR department and to see what positions are currently available.</h6></div><div class=\"footer-right-header careers-spacing\"><h6>Why 2-COM?</h6></div><div class=\"footer-right-content-careers careers-spacing\"><h6>We provide all of our 2-COM team members with unique opportunities in a collaborative, creative environment. We are proud of our global reputation and look to our staff to uphold high standards and maintain successful client relationships.</h6></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 no-padding-mobile\"><div class=\"footer-right\"><div class=\"footer-right-content\"><div class=\"footer-right-content-careers\"><h6>2-COM is an Equal Opportunity Employer.</h6></div><div class=\"footer-right-content-linkedin\"><a href=\"https://www.linkedin.com/company/100149\" target=\"_blank\">Follow our company on LinkedIn.</a></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/contact/contact.html","<div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"col-sm-1-1\"><div ng-show=\"vm.error\" class=\"contact-error\"><span>{{vm.errorDesc}}</span></div></div><form name=\"forms.contactForm\" id=\"contactForm\" ng-show=\"!vm.submitted\" class=\"grid form\"><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"NameContact\" class=\"form-label required-mark\">Name</label> <input ng-model=\"contact.name\" type=\"text\" id=\"NameContact\" name=\"NameContact\" value=\"\" class=\"form-control required\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"EmailContact\" class=\"form-label required-mark\">Email</label> <input ng-model=\"contact.email\" type=\"email\" id=\"EmailContact\" name=\"EmailContact\" value=\"\" class=\"form-control required\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"PhoneContact\" class=\"form-label required-mark\">Phone</label> <input ng-model=\"contact.phone\" type=\"text\" id=\"PhoneContact\" name=\"PhoneContact\" value=\"\" class=\"form-control required\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><label for=\"MessageContact\" class=\"form-label required-mark\">Message</label> <textarea ng-model=\"contact.message\" type=\"text\" id=\"MessageContact\" name=\"MessageContact\" value=\"\" class=\"form-control required\"></textarea></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><label class=\"form-label\">I am Interested in:</label><div class=\"radio-button grid\"><div class=\"col-sm-1-2\"><label for=\"InterestedMarketing\" class=\"form-label contact-checkbox\"><input ng-model=\"contact.interestedMarketing\" type=\"checkbox\" id=\"InterestedMarketing\" name=\"InterestedMarketing\" value=\"{{ checkbox.value }}\">Marketing logistics for enterprise</label> <label for=\"InterestedLearning\" class=\"form-label contact-checkbox\"><input ng-model=\"contact.interestedLearning\" type=\"checkbox\" id=\"InterestedLearning\" name=\"InterestedLearning\" value=\"Learning more about your capabilities\">Learning more about your capabilities</label></div><div class=\"col-sm-1-2\"><label for=\"InterestedCustomized\" class=\"form-label contact-checkbox\"><input ng-model=\"contact.interestedCustomized\" type=\"checkbox\" id=\"InterestedCustomized\" name=\"InterestedCustomized\" value=\"Customized solutions\">Customized solutions</label> <label for=\"InterestedOther\" class=\"form-label contact-checkbox\"><input ng-model=\"contact.interestedOther\" type=\"checkbox\" id=\"InterestedOther\" name=\"InterestedOther\" value=\"Other\">Other</label></div></div></div></div><div class=\"col-sm-1-1\"><div vc-recaptcha=\"\" key=\"vm.key\" ng-model=\"contact.captchaResponse\" class=\"recaptcha\"></div></div><div class=\"col-sm-1-1\"><div class=\"form-group\"><btn data-ng-disabled=\"progress.active()\" type=\"submit\" value=\"Submit\" ng-click=\"submitData(contact, \'ajaxSubmitResult2\')\" class=\"btn submit-btn\">Submit</btn></div></div></form><div ng-show=\"vm.submitted\" class=\"contact-submitted\"><h6>Thank you! We will be in touch with you soon.</h6></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 contact-right-pane\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 no-padding-mobile\"><div class=\"footer-right\"><div class=\"footer-right-header\"><h6>Corporate Office &amp; North American Distribution Center:</h6></div><div class=\"footer-right-content\"><h6 class=\"footer-right-content-address\">8110 Isabella Lane</h6><h6 class=\"footer-right-content-address\">Brentwood, TN 37027</h6><div class=\"footer-right-content-contact\"><h6>P: 615.371.5434</h6><h6>F: 615.371.8680</h6></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 no-padding-mobile\"><div class=\"footer-right\"><div class=\"footer-right-header\"><h6>Connect With 2-COM:</h6></div><div class=\"footer-right-content\"><div class=\"footer-right-content-social\"><a href=\"https://www.linkedin.com/company/100149\" target=\"_blank\">linkedin</a></div><div class=\"footer-right-content-social\"><a href=\"http://twitter.com/2ComNashville\" target=\"_blank\">twitter</a></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 no-padding-mobile\"><div class=\"footer-right\"><div class=\"footer-right-content\"><h6>&copy; {{ date | date: \'yyyy\' }} Communication Components</h6></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/footer/footer.html","<footer id=\"contact\" class=\"footer\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row tab-row\"><div ng-repeat=\"tab in vm.footerItems\" ng-class=\"{active:isActiveTab(tab.url)}\" ng-click=\"onClickTab(tab)\" class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 tab-header\"><h7>{{tab.title}}</h7></div><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-8 border-bottom\"></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div ng-show=\"elementTab === \'cc-contact\'\" class=\"footer-list-item-content\"><cc-contact></cc-contact></div><div ng-show=\"elementTab === \'cc-careers\'\" class=\"footer-list-item-content\"><cc-careers></cc-careers></div></div></div></footer>");
$templateCache.put("app/components/header/header.html","<section id=\"header\" class=\"header\"><div class=\"container-fluid\"><div class=\"header-image\"><img src=\"./../assets/img/header/header.png\"></div></div><div class=\"container-fluid\"><div class=\"container\"><div class=\"row\"><div class=\"header-announcement\"><div class=\"header-announcement-top\"><h1>Product Communications</h1></div><div class=\"header-announcement-bottom\"><h1>+ Marketing Logistics</h1></div></div></div></div></div></section>");
$templateCache.put("app/components/industries/industries.html","<section id=\"industries\" class=\"industries ss-style-triangles\"><div class=\"container-fluid\"><div class=\"container\"><div class=\"industries-header center\"><h1>Industries we serve</h1></div></div><div class=\"industries-container row center\"><div class=\"industries-list col-xs-12\"><div ng-repeat=\"item in vm.industriesItems\" ng-style=\"\" class=\"industries-list-item col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4\"><figure back-img=\"{{ item.background }}\" class=\"industries-list-item-background\"><img ng-src=\"url(./../assets/img/industries/{{ item.image }}\"><figcaption><h4 class=\"industries-list-item-name\">{{ item.name }}</h4><span class=\"industries-list-item-description\">{{ item.description }}</span></figcaption></figure></div></div></div></div></section>");
$templateCache.put("app/components/marketing/marketing.html","<section id=\"marketinglogistics\" class=\"marketing ss-style-triangles\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=\"center marketing-intro\"><h1>Marketing Logistics</h1></div></div></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=\"center marketing-blurb\"><p>2-COM leverages custom technology, data management, graphic design, production, warehousing, fulfillment and support solutions to streamline this process in enterprise applications.</p></div></div></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=\"center marketing-bold\"><h3>Browse some of our many capabilities:</h3></div></div></div><div class=\"row marketing-capabilities\"><div class=\"col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div ng-repeat=\"marketingItem in vm.marketingItems.slice(0, 4)\" class=\"marketing-capabilities-item col-xs-6 col-sm-3\"><div ng-style=\"{\'background-image\':\'url(./../assets/img/marketing/{{marketingItem.image}})\'}\" class=\"marketing-capabilities-item-image\"></div><h5 class=\"center\">{{ marketingItem.name }}</h5></div></div></div><div class=\"col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div ng-repeat=\"marketingItem in vm.marketingItems.slice(4, 8)\" class=\"marketing-capabilities-item col-xs-6 col-sm-3\"><div ng-style=\"{\'background-image\':\'url(./../assets/img/marketing/{{marketingItem.image}})\'}\" class=\"marketing-capabilities-item-image\"></div><h5 class=\"center\">{{ marketingItem.name }}</h5></div></div></div></div><div class=\"row marketing-capabilities marketing-capabilities-last\"><div class=\"col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div ng-repeat=\"marketingItem in vm.marketingItems.slice(8, 12)\" class=\"marketing-capabilities-item col-xs-6 col-sm-3\"><div ng-style=\"{\'background-image\':\'url(./../assets/img/marketing/{{marketingItem.image}})\'}\" class=\"marketing-capabilities-item-image\"></div><h5 class=\"center\">{{ marketingItem.name }}</h5></div></div></div><div class=\"col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div ng-repeat=\"marketingItem in vm.marketingItems.slice(12, 16)\" class=\"marketing-capabilities-item col-xs-6 col-sm-3\"><div ng-style=\"{\'background-image\':\'url(./../assets/img/marketing/{{marketingItem.image}})\'}\" class=\"marketing-capabilities-item-image\"></div><h5 class=\"center\">{{ marketingItem.name }}</h5></div></div></div></div></div></section>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar\"><div class=\"container\"><div class=\"navbar-header\"><button ng-click=\"isCollapsed = !isCollapsed\" class=\"navbar-toggle collapsed btn\"><span class=\"sr-only\">Menu<i class=\"fa fa-bars\"></i></span></button><a href=\"/\" class=\"navbar-brand\"><img src=\"./assets/img/navbar/logo.png\"></a></div><div id=\"navbar\" uib-collapse=\"isCollapsed\" class=\"navbar-collapse collapse\"><ul class=\"nav navbar-nav navbar-right\"><li ng-repeat=\"navbarItem in vm.navbarItems\"><a ng-click=\"gotoElement( \'{{ navbarItem.href }}\' )\">{{ navbarItem.text }}</a><span class=\"mobile-hide\">{{$last ? \'\' : ($index==Users.length-2) ? \' and \' : \' / \'}}</span></li></ul></div></div></nav>");
$templateCache.put("app/components/quote/quote.html","<div ng-repeat=\"quoteItem in vm.quoteItems.slice(0, 1)\" ng-init=\"x = getRandomIndex(vm.quoteItems)\" class=\"quote-source\"><div class=\"quote-content\"><p class=\"radikal\">{{vm.quoteItems[x].quote}}</p></div><div class=\"quote-source\"><p class=\"italic\">{{vm.quoteItems[x].source}}</p></div></div>");
$templateCache.put("app/components/team/team.html","<section id=\"team\" class=\"team ss-style-triangles\"><div class=\"container-fluid\"><h1 class=\"center\">THE TEAM</h1><div class=\"row\"><div ng-repeat=\"teamItem in vm.teamItems\" class=\"team-item center col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-2\"><div class=\"team-item-image\"><image src=\"/assets/img/team/{{teamItem.image}}\"></image></div><h3>{{ teamItem.name }}</h3><p class=\"title\">{{ teamItem.title }}</p><p class=\"fact\">{{ teamItem.fact }}</p></div></div></div></section>");}]);